/**
 * Created by sung on 2017-02-07.
 */
import {Component, NgModule, OnInit, ViewChild, Pipe, PipeTransform, ViewEncapsulation} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,PaginatorModule,ButtonModule,ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';
import {MenuItem, SelectItem} from "primeng/components/common/api";
import {Router, RouterModule} from "@angular/router";
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {SearchModule} from "../../component/search.component";
import {CompanyTreeModule} from "./company_tree";
import { MamAdminService } from '../../service/mam_service.component';
import { Device } from '../../model/device';
import {ExDialogModule} from "../../component/dialog.component";
import { InstalledApp } from '../../model/installedapp';
import { VersionedApp } from '../../model/versionedapp';
import {UserGroupTreeModule} from "../../component/user_tree.component";
import {Paginator} from "primeng/components/paginator/paginator";
import {AttributeGroupTreeModule} from "../../component/attribute-group-tree/attribute-group-tree.component";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";
import {StringDatePipe} from "../../pipe/string_dateFormat.pipe";
import {DatexPipe} from "../../pipe/datex.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import * as glob from "../../service/global_url";

@Component({

  selector: 'condition',
  templateUrl: './device_condition.html',
  encapsulation: ViewEncapsulation.None
})

export class DeviceConditionComponent implements OnInit{

  @ViewChild('pagi') pagi : Paginator;
  items : MenuItem[];
  index : number;
  private device_list : Device[] = [];
  private installApp_list : InstalledApp[] = [];
  private versionedapp_list : VersionedApp[] = [];

  // 등록됨
  private LANG_isRegistered : string;
  // 미등록
  private LANG_NotRegistered : string;
  // 설치됨
  private LANG_APP_installed : string;
  // 미설치
  private LANG_APP_notInstalled : string;
  // 최신
  private LANG_APP_Latestversion : string;
  // 이전
  private LANG_APP_PreviousVersion : string;
  // 루팅됨
  private IsRooting : string;
  // 정상
  private LANG_NoRoot : string;
  //동의
  private LANG_Consent_Person_info_Consent : string;
  totalRecord: number=0;
  licenseCount: number=0;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  otp : string;

  searchIsTrue : boolean = false;
  excelIsTrue : boolean = true;
  searchText: string;
  searchId : string;
  sDate : string;
  eDate : string;
  pageMax:number =10;
  resetIsTrue : any = "true";

  title : string;
  detailShow : boolean;
  logShow : boolean;
  installShow : boolean;
  policyShow : boolean;
  dialogWidth : string;
  detailSelected : any;
  logList : any;
  conditionList : any;

  installUserApp : any;
  officeTotalRecord : number = 5;
  userTotalRecord : number= 5;

  selectedCompany : any;
  deviceVersionedAppList : any;
  InstallAppForDevice : any;
  temp : any;

  selected_group : any;

  groupDeviceList : any;
  groupSelected : boolean = false;

  type : any;
  //설치버튼
  selectOfficeApp : any;
  private translate:TranslateServiceForm;

  nambuIsTrue:boolean = glob.nambuIsTrue;

  constructor(private service :MamAdminService, private confirmationService : ConfirmationService,private  router: Router, private _translate: TranslateServiceForm, private logger : Logger){
    this.searchIDs = [];
    this.searchIDs.push({label: '-----------------', value: 'all'});
    this.searchIDs.push({label: this._translate.instant('LANG_USR_user'), value: 'name'});
    //this.searchIDs.push({label: this._translate.instant('LANG_MemberNum'), value: 'membernum'});
    this.searchIDs.push({label: this._translate.instant('LANG_PhoneNumber'), value: 'mobilenumber'});
    this.searchIDs.push({label: this._translate.instant('IsRegistered'), value: 'isRegistered'});
	// this.searchIDs.push({label: this.otp, value: 'otp'});
    //this.searchIDs.push({label: this._translate.instant('IsLastVersion'), value: 'isLastVersion'});

    this.dateIsTrue = false;
    this.translate = _translate;
    this.LANG_isRegistered = this.translate.instant('LANG_isRegistered');
    this.LANG_NotRegistered = this.translate.instant('LANG_NotRegistered');

    this.LANG_APP_installed = this.translate.instant('LANG_APP_installed');
    this.LANG_APP_notInstalled = this.translate.instant('LANG_APP_notInstalled');

    this.LANG_APP_Latestversion = this.translate.instant('LANG_APP_Latestversion');
    this.LANG_APP_PreviousVersion = this.translate.instant('LANG_APP_PreviousVersion');

    this.IsRooting = this.translate.instant('IsRooting');
    this.LANG_NoRoot = this.translate.instant('LANG_NoRoot');

    this.LANG_Consent_Person_info_Consent = this.translate.instant('LANG_Consent_Person_info_Consent');
  }
  ngOnInit(){
    //this.getDeviceCondition(1,10,'2016-01-01','2017-02-17', '','','');
    //this.getInstalledAppForDevice(1,1,10);
    //this.getDeviceCondition(1,10,'2016-01-01','2017-02-17','01092986589','true','mobileNumber');
    //this.getGroupDeviceBySearch(1,0,10, 't15', 'name');
    // this.getGroupDeviceBySearch(1,1,10, 't16', 'name');
    // this.getGroupDeviceBySearch(1,1,10, 't17', 'name');
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    
    if(this.groupSelected){
      if(this.searchId == "all"){
        this.searchIsTrue = false;
        this.getGroupDevice(this.selected_group.id,event.page,this.pageMax);
      }else{
        this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
      }
    }
    //this.getGroupDeviceBySearch(this.selected_group.id,event.page,this.pageMax, this.searchText, this.searchId);
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getGroupDeviceBySearch(this.selected_group.id, event.page, this.pageMax, this.searchText, this.searchId);
    } else {
      //this.getDeviceCondition(event.page + 1,this.pageMax,'2016-12-12','2017-02-02',"","","");
      this.getGroupDevice(this.selected_group.id,event.page,this.pageMax);
    }

  }


  getDeviceCondition(page:number, max:number, start:string, end:string, search:string, like:string, field:string) {
    this.service.getDeviceCondition(page, max, start, end, search, like, field).subscribe(
        value => {
          this.device_list = value.rows;
          this.totalRecord = value.total;
          this.logger.debug("-- device_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }
  private convertRemoteCommandToUXstr (controlLog:any) : any {
    let commandString:string = controlLog.message;
    let messageString:string = "";
    let additionalMessage:string = "";
    let tokens:string[] = commandString.split("_");

    if("GET_SYSTEM-INFO" == commandString) {
      messageString = "RC_GET_SYSTEM_INFO";
    } else if ("GET_ALL-APPS" == commandString) {
      messageString = "RC_GET_ALL_APPS";
    } else {
      if( tokens == null ){
        messageString = this.getUXstr(commandString);
      } else {
        let command:string = tokens[0];

        if("SET" == command) {
          if( tokens.length < 3 ) {
            messageString = this.getUXstr(commandString);
          } else {
            if("PWD" == tokens[1]) {
              messageString = this.getUXstr(command + "_" + tokens[1]);
            } else {
              messageString = this.getUXstr("SET_" + tokens[1]);
              additionalMessage =  ": " + tokens[2];
            }
          }
        } else if ("APP" == command) {
          if( tokens.length < 3 ) {
            messageString = this.getUXstr(commandString);
          } else {
            let command2 = tokens[1];
            messageString = this.getUXstr(command + "_" + command2);
            if("INSTALL" == command2 || "REMOVE" == command2) {
              let len:string = command + "_" + command2 + "_";
              let st:string[] = commandString.substring(len.length).split("|");
              if(st.length == 2) {
                let name = st[0];
                let packageName = st[1];
                additionalMessage =  ": " + name + " : " + packageName;
              } else {
                additionalMessage =  ": " + tokens[2];
              }
            }
          }
        } else if ("LOST" == command) {
          messageString = this.getUXstr(command);
        } else if("FOUND" == command) {
          messageString = this.getUXstr(command);
        } else {
          let uxStr:string = this.getUXstr(commandString);
          if( uxStr != null && uxStr.length > 0 ) {
            messageString =  uxStr;
          }
        }
      }
    }

    controlLog.message = this._translate.instant(messageString) + additionalMessage;
    controlLog.status = this._translate.instant(this.getUXstr(controlLog.status));
    return controlLog;

  }

  private getUXstr(key:string):string {
    return "RC_"+key;
  }
  getControlLogForDevice(page:number, max:number,deviceId:number) {
    this.service.getControlLogForDevice(page, max, deviceId).subscribe(
        value => {
          this.logList = value.content;
          this.logger.info("-- log_list :", value);
          for(var i=0; i < this.logList.length; i++) {
            this.logList[i] = this.convertRemoteCommandToUXstr(this.logList[i]);
            //this.logList[i].status = this.translate.instant("RC_"+this.logList[i].status);

          }

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getTargetPolicyConditionList(policyId:number) {
    this.service.getTargetPolicyConditionList(policyId).subscribe(
        value => {
          this.type = value.type;
          if(value.type == "NORMAL"){
            this.conditionList = value.conditions;
            if(this.conditionList && this.conditionList.length > 0){
              this.conditionList.forEach(conditionList =>{
                conditionList.controls.forEach(control => {
                  control.controlClass.name = this.translate.instant("MdmPolicyControlName_"+control.controlClass.name);
                  control.controlClass.value = this.translate.instant(control.controlClass.value);
                });
              });
            }
          }else if(value.type == "PASSING"){
            let inout = this.detailSelected.nowPolicyControl;
            this.conditionList = [];
            this.conditionList = value.conditionItems;
            if(this.conditionList){
              let conditionList = this.conditionList[inout];
              for(let i=0; i<conditionList.length; i++){
                let temp = conditionList[i];
                temp.controlClass.name = this.translate.instant("MdmPolicyControlName_"+temp.controlClass.name);
                temp.controlClass.value = this.translate.instant(temp.controlClass.value);
              }
              this.conditionList = conditionList;
            }
          }

          this.logger.debug("-- policyCondition_list :", this.conditionList);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }
  //사용자앱설치현황
  getInstalledAppForDevice(deviceId:number, page:number, max:number) {
    this.service.getInstalledAppForDevice(deviceId,page, max).subscribe(
        value => {
          var urlContextPath = this.getContextPathURL();
          this.installUserApp = value.rows;
          this.userTotalRecord = value.total;
          this.logger.debug("-- installApp_list :", value);


          if(this.installUserApp && this.installUserApp.length > 0){
            this.installUserApp.forEach(item => {


              let del = urlContextPath + 'resource/image/btn_s_trash_off.png';
              let run = urlContextPath + 'resource/image/btn_s_run_off.png';
              let delIsTrue = false;
              let runIsTrue = false;

              let hasDeletedApp = item.msAppType == "ALLOW_DELETE_APP"?true:false;
              let type = item.app.appType;
              if(type == "WINDOWS_OS" || type == "WINDOWS_PHONE"){
                if(hasDeletedApp){
                  del = urlContextPath + 'resource/image/btn_s_trash_on.png'; delIsTrue = true;
                }
              }else{
                del = urlContextPath + 'resource/image/btn_s_trash_on.png'; delIsTrue = true;
                if(item.device.deviceTypeId.osName == "Android") { run = urlContextPath + 'resource/image/btn_s_run_on.png'; runIsTrue = true;}
              }
              item.del = del;
              item.delIsTrue = delIsTrue;
              item.run = run;
              item.runIsTrue = runIsTrue;
            });
          }

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getVersionedappListForDevice(deviceId: number, page: number, max: number) {
    this.service.getVersionedappListForDevice(deviceId, page, max).subscribe(
        value => {
          this.deviceVersionedAppList = value.rows;
          this.officeTotalRecord = value.total;
          this.logger.debug("-- deviceVersionedAppList :", value);


          this.getInstallAppForDevice(deviceId);  //  업무 앱 설치 현황               //앱 설치된거 쭈우우욱
          this.getInstalledAppForDevice(deviceId,1,5);      //사용자 앱 설치현황

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getInstallAppForDevice(deviceId:number) {
    this.service.getInstallAppForDevice(deviceId).subscribe(
        value => {
          this.InstallAppForDevice  = value;
          let vendor = this.detailSelected.vendor;
          this.logger.debug("-- getInstallAppForDevice :", value);
          var urlContextPath = this.getContextPathURL();
          //console.log("contextRoot : "+urlContextPath);
          if(this.deviceVersionedAppList && this.deviceVersionedAppList.length > 0){


            this.deviceVersionedAppList.forEach(temp=>{
              let del = urlContextPath + 'resource/image/btn_s_trash_off.png';
              let ins = urlContextPath + 'resource/image/btn_s_install_on.png';
              let upd = urlContextPath + 'resource/image/btn_s_update_off.png';
              let run = urlContextPath + 'resource/image/btn_s_run_off.png';
              let delIsTrue = false;
              let insIsTrue = true;
              let updIsTrue = false;
              let runIsTrue = false;

              this.InstallAppForDevice.forEach(item => {
                if(item.app.packageName == temp.packageName){

                  if(vendor == temp.agentDeviceVendor || temp.agentDeviceVendor == "OTHER"){
                    del = urlContextPath + 'resource/image/btn_s_trash_on.png'; delIsTrue = true;
                    ins = urlContextPath + 'resource/image/btn_s_install_off.png'; insIsTrue = false;
                    temp.installedDate = item.installedDate;

                    if(temp.versionName != item.installedVersion){
                      upd = urlContextPath + 'resource/image/btn_s_update_on.png'; updIsTrue = true;
                    }

                    if(item.device.deviceTypeId.osName == "Android") { run = urlContextPath + 'resource/image/btn_s_run_on.png'; runIsTrue = true;}
                    return;
                  }

                }

              });

              temp.del = del;
              temp.delIsTrue = delIsTrue;
              temp.ins = ins;
              temp.insIsTrue = insIsTrue;
              temp.upd = upd;
              temp.updIsTrue = updIsTrue;
              temp.run = run;
              temp.runIsTrue = runIsTrue;
              this.logger.debug("temp",temp);

            });
          }

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getGroupDevice(attId: number, page: number, size: number){
    this.service.getGroupDevice(attId,page,size).subscribe(
        value => {
          this.groupDeviceList = value.content;
          this.totalRecord = value.totalElements;
          this.licenseCount = value.licenseCount;

          this.logger.debug("---pagi : ",this.pagi);
          this.logger.debug("-- groupDeviceList : ",this.groupDeviceList);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getGroupDeviceBySearch(groupId:number,page:number,size:number, search:string, field:string){
    this.service.getGroupDeviceBySearch(groupId,page,size,search,field).subscribe(
        value => {
          this.groupDeviceList = value.content;
          this.totalRecord = value.totalElements;
          this.licenseCount = value.licenseCount;
          
          this.logger.debug("---pagi : ",this.pagi);
          this.logger.debug("-- getGroupDeviceBySearch : ",this.groupDeviceList);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  /* command Ex
   if(type == 'install' || type == 'update'){
   if(downloads==''){
   alert($.i18n.prop("MESSAGE_ALERT_NOT_EXIST_APP", appName));
   return false;
   }
   rUrl = "&command=APP_INSTALL&args[]="+appName+"&args[]="+appPackageName+"&args[]="+downloads;
   }else if(type == 'delete'){
   rUrl = "&command=APP_REMOVE&args[]="+appName+"&args[]="+appPackageName;
   }else if(type == 'run'){
   rUrl = "&command=APP_RUN&args[]="+appPackageName;
   }else if(type == 'allApps'){
   rUrl = "&command=GET&args[]=ALL-APPS";
   }
   */

  userDeviceDelete(item) {
    console.log(item);
    if(confirm(this.translate.instant('MESSAGE_ALERT_CONFIRM_DELETE'))) {
      this.service.deleteUserDevice(item.owner.id, item.id).subscribe(
        value => {
          this.logger.debug("value",value);
          alert(value);
          this.getGroupDevice(this.selected_group.id,0,10); 
        },error => {
          this.logger.error("-- error : " + error);
        }
      )
    }
  }
  
  // otp
  deviceOtpDelete(item) {
	console.log(item);
	this.service.getOtpByDevice(item.authToken).subscribe(
	  value => {
	    this.logger.debug("value",value);
	    this.getGroupDevice(this.selected_group.id,0,10); 
	  },error => {
	    this.logger.error("-- error : " + error);
	  }
	)
  }

  selectDetailDevice(item){
    this.logger.debug("item",item);
    this.title = this.translate.instant('LANG_Detail');
    this.dialogWidth = '600px';
    this.detailShow = true;
    this.detailSelected = item;
    this.logger.debug("detail Selected " ,this.detailSelected);
  }
  selectViewPolicy(item){
    this.detailSelected = item;
    this.title = this.translate.instant('LANG_POLICY_PolicyApplyStatus');
    //this.dialogWidth = '1200px';
    this.policyShow = true;
    //item.nowPolicy.id 로 정책 id 넘겨줘서 그 상태값들 받아와야함.
    this.getTargetPolicyConditionList(item.lastPolicyApplied.id);
    this.logger.debug(item);
  }
  selectViewLog(item){
    this.detailSelected = item;
    this.logShow = true;
    this.getControlLogForDevice(0,200,item.id);
    this.title = this.translate.instant('LANG_LOC_remoteCommandList');
    //this.dialogWidth = '600px';

  }
  selectViewInstall(item){
    if(!item.registered){
      alert(this.translate.instant('unknownDevice'));
      return;
    }

    this.detailSelected = item;
    this.installShow = true;
    this.title = this.translate.instant('LANG_BUTTON_APP');
    this.dialogWidth = '600px';
    this.getVersionedappListForDevice(item.id,1,5);        // 업무앱리스트 가져오는것,.
    //this.getInstallAppForDevice(item.id);  //  업무 앱 설치 현황               //앱 설치된거 쭈우우욱
    //this.getInstalledAppForDevice(item.id,1,5);      //사용자 앱 설치현황

    this.logger.debug(item.id);
  }

  selectViewRemote(item){
    this.confirmationService.confirm({
      message: this.translate.instant('LANG_loadRemoteConrolPage'),
      header: this.translate.instant('LANG_DeviceRemoteManage'),
      accept: () => {
        let link = ['home/device/remoteManagement'];
        this.router.navigate(link);
      }
    });
  }
  confirm(event){
    this.detailShow = false;
    this.logShow = false;
    this.policyShow =false;
    this.installShow = false;

    this.getGroupDevice(this.selected_group.id,0,this.pageMax);

  }

  setStatusPush(deviceId:number, command:string, args:any){
    this.service.setStatus(deviceId,command,args).subscribe(
        value =>{
          this.logger.debug("setStatus Result : ",value);
          if(value.indexOf(0)>-1){
            this.getVersionedappListForDevice(this.detailSelected.id,1,5);
            //this.getInstalledAppForDevice(this.detailSelected.id,1,5);      //사용자 앱 설치현황
            //this.getInstallAppForDevice(this.detailSelected.id);  //  업무 앱 설치 현황
          }
        },
        error => { this.logger.error("-- error : " + error); }
    )
  }
  appCRUD(app,state,command){
    if(state){
      this.logger.debug(app);
      let item = [];
      if(command == "APP_INSTALL"){
        item.push(app.name);
        item.push(app.packageName);
        item.push(app.id);
      }else if(command == "APP_REMOVE"){
        item.push(app.name);
        item.push(app.packageName);
      }else if(command == "APP_RUN"){
        item.push(app.packageName);
      }else if(command == "GET"){
        item.push("ALL-APPS");
        this.logger.debug("item",item);
      }
      this.setStatusPush(this.detailSelected.id,command,item);

    }

  }
  userAppDR(app,state,command){
    if(state){
      this.logger.debug(app);
      let item =[];
      if(command == "APP_REMOVE"){
        item.push(app.app.name);
        item.push(app.app.packageName);
      }else if(command == "APP_RUN"){
        item.push(app.app.packageName);
      }
      this.setStatusPush(this.detailSelected.id,command,item);
    }
  }
  /*officeAppDelete(app, state){
   if(state){
   let item = {appId : app.id,appName : app.appName, appPackageName : app.appPackageName};
   this.setStatusPush(this.detailSelected.id,"delete",item);
   //this.logger.debug(app);
   }
   }

   officeAppInstall(app, state){
   if(state){
   let item = {appId : app.id,appName : app.appName, appPackageName : app.appPackageName};
   this.setStatusPush(this.detailSelected.id,"install",item);
   //this.logger.debug(app);
   }
   }

   officeAppUpdate(app, state){
   if(state){
   let item = {appId : app.id,appName : app.appName, appPackageName : app.appPackageName};
   this.setStatusPush(this.detailSelected.id,"update",item);
   //this.logger.debug(app);
   }
   }*/

  paginateOffice(event){
    this.getVersionedappListForDevice(this.detailSelected.id,event.page + 1,event.rows);
  }

  paginateUser(event){
    this.getInstalledAppForDevice(this.detailSelected.id,event.page + 1,event.rows);
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  onGroupSelect(event){
    this.logger.debug("selected group : " , event);
    this.selected_group = event;
    this.groupSelected = true;
    this.resetIsTrue = "true"+event.id;
    if(this.pagi){
      this.pagi.first=0;
    }
    this.getGroupDevice(this.selected_group.id,0,this.pageMax);
  }

  excelExport(event){
    //this.logger.debug("excel 다운 : ",event);
    console.log("excel 다운 : ",event);
    if(event){
      //엑셀 다운 진행.
      var url = this.service.getUrl() + "/mgr/device/company/" + this.selectedCompany.id+"/download/excel";
      window.open(url);
    }
  }

  getContextPathURL() {
    var para = location.href.split("#")[0];
    //console.log(para);
    return para;
  };

}

@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,CommonModule,FormsModule,SearchModule,CompanyTreeModule,PaginatorModule,ButtonModule,ExDialogModule,ConfirmDialogModule,UserGroupTreeModule,AttributeGroupTreeModule,CompanyDropDownListModule,MainPipeMoudle,TranslatePipeMoudle],
  exports: [DeviceConditionComponent],
  declarations: [DeviceConditionComponent,StringDatePipe],
  providers: [MamAdminService,ConfirmationService],
})

export class DeviceConditionModule {
}



// WEBPACK FOOTER //
// ./src/app/page/device/device_condition.ts